  import React, { useEffect, useRef, useState } from 'react';
  import { mockPortfolioData } from '../data/mockData';

  const Portfolio = ({ setSelectedProject }) => {
    const portfolioRef = useRef(null);
    const [activeFilter, setActiveFilter] = useState('all');
    const [filteredProjects, setFilteredProjects] = useState(mockPortfolioData);

    // Re-animate setiap kali daftar proyek berubah
    useEffect(() => {
      const portfolioSection = portfolioRef.current;
      if (!portfolioSection) return;

      // Reset state animasi dulu
      const items = portfolioSection.querySelectorAll('.portfolio-item');
      items.forEach((item) => {
        item.classList.remove('animate-slide-up');
        item.classList.add('opacity-0', 'translate-y-10');
      });

      // Buat observer baru
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in');

            // Animate item satu per satu
            const items = entry.target.querySelectorAll('.portfolio-item');
            items.forEach((item, index) => {
              setTimeout(() => {
                item.classList.add('animate-slide-up');
                item.classList.remove('opacity-0', 'translate-y-10');
              }, index * 100);
            });
          }
        },
        { threshold: 0.1 }
      );

      observer.observe(portfolioSection);
      return () => observer.disconnect();
    }, [filteredProjects]); // <— tambahkan dependensi ini agar dipicu setiap filter berubah

    // Filter logic
    useEffect(() => {
      if (activeFilter === 'all') {
        setFilteredProjects(mockPortfolioData);
      } else {
        const filtered = mockPortfolioData.filter(
          (project) => project.category === activeFilter
        );
        setFilteredProjects(filtered);
      }
    }, [activeFilter]);

    const filterButtons = [
      { id: 'all', label: 'Semua' },
      { id: 'photography', label: 'Fotografi' },
      { id: 'videography', label: 'Videografi' },
      { id: 'editing', label: 'Editing' },
    ];

    const handleProjectClick = (project) => {
      setSelectedProject(project);
    };

    return (
      <section
        id="portfolio"
        ref={portfolioRef}
        className="py-20 lg:py-32 bg-gray-50 dark:bg-gray-800 opacity-0 transition-all duration-1000"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-6">
              Portofolio Kami
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto mb-12">
              Jelajahi koleksi karya visual kami yang telah dipercaya oleh berbagai klien
            </p>

            {/* Filter buttons */}
            <div className="flex flex-wrap justify-center gap-4 mb-12">
              {filterButtons.map((button) => (
                <button
                  key={button.id}
                  onClick={() => setActiveFilter(button.id)}
                  className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                    activeFilter === button.id
                      ? 'bg-gray-900 text-white dark:bg-white dark:text-gray-900 shadow-lg transform scale-105'
                      : 'bg-white text-gray-900 dark:bg-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 shadow-md hover:shadow-lg hover:scale-105'
                  }`}
                >
                  {button.label}
                </button>
              ))}
            </div>
          </div>

          {/* Portfolio grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8">
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                className="portfolio-item opacity-0 transform translate-y-10 transition-all duration-700 cursor-pointer group"
                onClick={() => handleProjectClick(project)}
              >
                <div className="relative overflow-hidden rounded-xl shadow-lg group-hover:shadow-2xl transition-all duration-300">
                  <div className="aspect-square bg-gray-200 dark:bg-gray-700">
                    <img
                      src={project.thumbnail}
                      alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>

                  {/* Overlay */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                    <div className="text-center transform translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                      <h3 className="text-white text-lg font-semibold mb-2">
                        {project.title}
                      </h3>
                      <p className="text-gray-200 text-sm capitalize">{project.category}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredProjects.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-500 dark:text-gray-400 text-lg">
                Tidak ada proyek yang ditemukan untuk kategori ini.
              </p>
            </div>
          )}
        </div>
      </section>
    );
  };

  export default Portfolio;
